"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_checker_1 = require("../client-checker");
var componentName = 'split-page';
exports.default = {
    name: componentName,
    functional: true,
    props: {
        textVariant: {
            type: [Boolean, String],
            default: false
        }
    },
    render: function (h, ctx) {
        var client = client_checker_1.useClientChecker();
        var textVariant = ctx.props.textVariant.toString() == 'true';
        return h('div', {
            class: [
                'split-page__wrapper',
                { 'split-page__wrapper--text': textVariant },
                ctx.data.staticClass
            ],
        }, [
            h('main', { class: 'split-page__main-wrapper' }, [
                h('div', { class: 'split-page__main' }, [
                    h('div', { class: 'split-page__content-wrapper' }, [
                        ctx.slots().default,
                        ctx.slots().beforecontent && h('div', { class: 'split-page__before-content' }, [
                            ctx.slots().beforecontent
                        ]),
                        ctx.slots().content && h('div', { class: 'split-page__content' }, [
                            ctx.slots().content
                        ]),
                        ctx.slots().aftercontent && h('div', { class: 'split-page__after-content' }, [
                            ctx.slots().aftercontent
                        ])
                    ])
                ])
            ]),
            h('div', { class: 'split-page__identity' }, [
                h('img', { attrs: { src: appropriateIdentitySrc(client) } })
            ])
        ]);
    }
};
function appropriateIdentitySrc(client) {
    var isToolbox = client.clientIsToolbox.value;
    var isYesly = client.clientIsYesly.value || client.clientIsGoogleYesly.value || client.clientIsAlexaYesly.value;
    var isBliss = client.clientIsBliss.value || client.clientIsBliss2.value || client.clientIsGoogleBliss.value || client.clientIsAlexaBliss.value;
    if (isToolbox) {
        return '/images/logo-toolbox.svg';
    }
    else if (isYesly) {
        return '/images/logo-yesly-white.svg';
    }
    else if (isBliss) {
        return '/images/logo-bliss-white.svg';
    }
    else {
        return '/images/logo-finder-white.svg';
    }
}
